import { Injectable } from '@angular/core';
import { GenericsService } from './generics.service';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root'
})
export class KanbanService {

  constructor(private generics: GenericsService, 
              private login:LoginService) { }

  setAtividade(projeto:string, atividade:string, obj:any) {
    //console.log(">>", atividade);
    if (atividade != '') 
      return this.generics.put('projeto/' + projeto + '/atividade/' + atividade, obj);
    else 
      return this.generics.post('projeto/' + projeto + '/atividade', obj);
  }

  setTarefa(projeto:string, atividade:string, obj:any) {
    //console.log(">>", atividade);
    if (parseInt(obj.id) > 0) {
      let id = obj["id"];
      delete obj["id"];
      return this.generics.put('projeto/' + projeto + '/atividade/' + atividade + '/tarefa/' + id, obj);
    } else 
      return this.generics.post('projeto/' + projeto + '/atividade/' + atividade + '/tarefa', obj);
  }

  removeTarefa(projeto:string, atividade:string, tarefa:string) {
    return this.generics.delete('projeto/' + projeto + '/atividade/' + atividade + '/tarefa/' + tarefa);
  }

  concluirAtividade(obj:any) {
    //console.log(obj);
  }

  removerAtividade(projeto, atividade) {
    return this.generics.delete('projeto/' + projeto + '/atividade/' + atividade);
  }
          
  getAtividades(projeto:string) {
    return this.generics.get('projeto/' + projeto + '/atividades');
  }

  setEstagio(projeto:string, atividade:string, estagio:string) {
    return this.generics.post('projeto/' + projeto + '/atividade/' + atividade + '/estagio', {idUsuario:this.login.getUsuario("id"), estagioDestino:estagio});
  }

  tarefa(projeto:number, atividade:number, estagio:string, obj:any) {
    return this.generics.post('projeto/' + projeto + '/atividade/' + atividade + '/tarefa', {obj});
  }

}
